import lod_ from "lodash";
import i18n from "i18n";
import React from "react";
import cockpitActions from "redux/actions/cockpitActions";
import { infoMsg } from "redux/reducers/snackMsgsReducers";
import { validateEmail } from "helpers/utilities";
import AutoSendConversationDialog from "../AutoSendConversationDialog";
import { hasOneIncomingMessageOnly } from "../business/autoSendForward";

/**
 * Get the "to" of the action config if it is a valid email
 * @param {object} action the action of the assistantConfig
 * @returns {string|undefined} the trimmed email, undefined if the agent has to fill it
 */
function getValidConfigTo(action) {
	const configTo = action?.config?.to;
	return lod_.isString(configTo) && validateEmail(configTo.trim()) ? configTo.trim() : undefined;
}

/**
 * Mass action of the forward with config.autoSend (type "forward"):
 * forwards automatically the first incoming message of each selected conversation
 */
const autoSendForwardMassAction = {
	/**
	 * Only the conversations with one incoming message and no answer can be forwarded
	 * @param {object} conversation the conversation of the list, with its meta counters
	 * @returns {boolean}
	 */
	isEligible: conversation => hasOneIncomingMessageOnly(conversation),

	// Displayed when no conversation of the list respects isEligible
	noConversationMessageKey: "COC.massConversationActionAutoSendNoConversation",

	/**
	 * Dialog of the agent confirmation: mail channel, then confirmation of the "to" of the config or email to fill
	 * @param {object} param0 the dialog parameters
	 * @param {object} param0.action the action of the assistantConfig
	 * @param {number} param0.conversationCount number of selected conversations
	 * @param {Function} param0.handleClose called on cancel
	 * @param {Function} param0.handleValidate called with the agent choice { channelCode, to }
	 * @returns {object} the dialog
	 */
	renderConfirmDialog: ({ action, conversationCount, handleClose, handleValidate }) => (
		<AutoSendConversationDialog
			open={true}
			configTo={getValidConfigTo(action)}
			conversationCount={conversationCount}
			handleClose={handleClose}
			handleValidate={handleValidate}
		/>
	),

	/**
	 * One action autoForwardMessage per conversation, NYO checks each of them again
	 * (filters, permissions) and forwards its first incoming message
	 * @param {object} param0 the execution parameters
	 * @param {object} param0.action the action of the assistantConfig
	 * @param {Array} param0.conversations the selected conversations
	 * @param {object} param0.result the agent choice in the dialog { channelCode, to }
	 * @param {Function} param0.dispatch the redux dispatch
	 */
	execute: ({ action, conversations, result, dispatch }) => {
		conversations.forEach(conversation => {
			dispatch(
				cockpitActions.launchActionFrontV2("autoForwardMessage", {
					header: {
						assistantID: conversation.header.assistantID,
						fID: conversation.header.fID
					},
					payload: {
						scope: "conversation",
						actionCode: action.code,
						channelCode: result.channelCode,
						to: result.to
					}
				})
			);
		});

		dispatch(
			infoMsg(i18n.t("messagesAction.autoForwardMassInProgress", { count: conversations.length }))
		);
	}
};

export default autoSendForwardMassAction;
